/**
 * @module cercaliagl/control/InfoMap
 */
import Control from './Control';
import MapControls from './MapControls';
import VInfoMap from '../view/VInfoMap';

/**
 * @classdesc
 *
 * @extends {Control}
 */
class InfoMap extends Control {
  /**
   * @constructor
   */
  constructor() {
    const vInfoMap = new VInfoMap();
    const element = vInfoMap.getElement();

    super({
      element,
      target: null,
      name: MapControls.INFOMAP,
    });

    /**
     * @private
     * @type {VInfoMap}
     */
    this.vInfoMap_ = vInfoMap;

    /**
     * @private
     * @type {import('../InfoMap').default|undefined}
     */
    this.infoMap_ = undefined;

    /**
     * @private
     */
    this.element_ = element;
  }

  /**
   * @param {import('../InfoMap').default} infoMap Info Map.
   */
  update(infoMap) {
    this.infoMap_ = infoMap;
    const title = this.infoMap_.getTitle();
    const content = this.infoMap_.getContent();
    this.vInfoMap_.setTitle(title);
    this.vInfoMap_.setContent(content);
  }

  /**
   * Close popup.
   */
  closePopup() {
    this.vInfoMap_.hide(false);
  }

  /**
   * Show popup
   */
  showPopup() {
    this.vInfoMap_.show(false);
  }
}

export default InfoMap;
